import { css } from 'linaria';
import { styled } from 'linaria/react';

export const CityPickerRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;

  button {
    white-space: nowrap;
    align-items: flex-end;
    & > div {
      display: flex;
      flex-direction: column;
      align-items: baseline;
    }
  }

  @media (--only-mobile) {
    padding-left: var(--space-150);
    button {
      transform: translateY(1px);
    }
  }
`;

export const cityPickerLabel = css`
  transform: translateY(-1px);
`;

export const hoveredText = css``;

export const hover = css`
  &:hover {
    background-color: initial !important;
    box-shadow: initial !important;
    .${hoveredText} {
      color: var(--brand-dark);
    }
    path {
      --i-color: var(--brand-dark);
    }
  }
`;
